<template>
  <div class="icon-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'iconGrid',
}
</script>

<style lang="scss" scoped>

.icon-box{
  width: 50%;
  flex:1;
  position: relative;

    &:after{
      content:'';
      // background-image: url(../../assets/Folded_Paper_icon_grid.png);
      max-width: 180px;
      max-height: 180px;
      width: 100%;
      height: 100%;
      position: absolute;
      top:0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
      @include opacityShowPositionSmall;
      z-index: -1;
    }
    img{
      margin: 0 auto; 
      display: block;
      max-width: 180px;
      max-height: 180px;
      width: 100%;
      height: 100%;
      margin-bottom: layout-val-8(4);

    }
    h2,p{
      text-align: center;
    }
    p{
      max-width: 95%;
    }
}
</style>